'use strict';
const html = document.documentElement;

window.addEventListener("load", () => {
  document.body.classList.add('page-load');

  let screenW       = html.clientWidth,
      pageHeader    = document.querySelector('.header'),
      dropMenu      = document.querySelector('.drop-content'),
      topOffset     = 0,
      pageOverlay   = initOverlay();

  /* ===========================
    #CLOSE PRESENT
  ============================= */
  let present = document.querySelector('.present');

  if(present) {
    present.onclick = function(e) {
      if(e.target.closest('.present__close-btn')) {
        this.classList.remove('is-visible');
        document.querySelector('.header__bottom-row').classList.add('hide-garantee');

        topOffset -= present.offsetHeight;

        pageHeader.style.transform = `translateY(-${present.offsetHeight}px)`;

        document.body.style.paddingTop = `${topOffset}px`;

        if(innerWidth < 1100) {
          dropMenu.style.paddingTop = `${topOffset}px`;
        }

        setTimeout(()=> {
          present.remove();
          pageHeader.style.transitionDuration = '0s';
          pageHeader.style.transform = '';
        }, 1000);
      };
    };
  };


  /* ===========================
    #ADD TOP OFFSET
  ============================= */

      if(present) {
        present.classList.add('is-visible');
      };

      topOffset += pageHeader.offsetHeight;

      document.body.style.paddingTop = `${topOffset}px`;

      if(window.innerWidth < 1100) {
        dropMenu.style.paddingTop = `${topOffset}px`;
      };


      window.addEventListener('resize', function(e) {

          if(innerWidth >= 1100) dropMenu.style.paddingTop = '';

          let currentOffset = pageHeader.offsetHeight;

          if(topOffset === currentOffset) return;

          topOffset = currentOffset;

          document.body.style.paddingTop = `${topOffset}px`;

          if(innerWidth < 1100) {
            dropMenu.style.paddingTop = `${topOffset}px`;
          };
      });

/* ===========================
  #FIXED SIDEBAR
============================= */

const bar = document.querySelector('.js-sidebar');
let parentCoords, topBound, botBound;
sidebar();

window.addEventListener('resize', function(e) {
  sidebar();
});

function sidebar() {

  if(bar && html.clientWidth >= 900) {
    parentCoords = getCoords(bar.parentNode),
    topBound     = Math.abs(parentCoords.top),
    botBound     = Math.abs(parentCoords.bottom);

    if(window.pageYOffset > 0) fix(bar);

    window.addEventListener('scroll', function(e) {
    
      let barCoords = bar.getBoundingClientRect();
      if(window.pageYOffset >= 0 && window.pageYOffset+html.clientHeight <= botBound && !bar.classList.contains('is-fixed')) {
        fix(bar);

      } else if(window.pageYOffset + html.clientHeight >= botBound) {
        unfix(bar, barCoords);
      } 

    });


    function fix(elem) {
      elem.classList.add('is-fixed');
      elem.style.width    = `${elem.offsetWidth}px`;
      elem.style.position = 'fixed';
      elem.style.left     = `${parentCoords.right - elem.offsetWidth}px`;
      elem.style.top      = `${topBound}px`;
    }

    function unfix(elem, coords) {
      elem.classList.remove('is-fixed');
      elem.style.width    = '';
      elem.style.position = 'relative';
      elem.style.left     = '';
      elem.style.top      = `${bar.parentNode.offsetHeight - bar.offsetHeight}px`;
    }
  }
}

  /* ===========================
    #SWIPER
  ============================= */
  if (document.querySelector('.swiper-container')) {

    const gallerySlider = new Swiper('.gallery-slider .swiper-container', {
      // Optional parameters
      loop: true,

      // Navigation arrows
      navigation: {
        nextEl: '.gallery-slider .swiper-button-next',
        prevEl: '.gallery-slider .swiper-button-prev',
      },

    });

    const teamSlider = new Swiper('.our-team-slider .swiper-container', {
      slidesPerView: 1,
      loop: true,
      breakpoints: {
        // when window width is >= 900px

        475: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: 5,
          spaceBetween: 45
        },
      },

      pagination: {
        el: '.our-team-slider .swiper-pagination',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          if (current < 10) {
            current = `0${current}`;
          }

          if (total < 10) {
            total = `0${total}`;
          }

          return `<span class="swiper-pagination-current">${current}</span> &mdash; <span class="swiper-pagination-total">${total}</span>`
        }
      },

      navigation: {
        nextEl: '.our-team-slider .swiper-button-next',
        prevEl: '.our-team-slider .swiper-button-prev',
      }
    });

    const team = document.querySelector('.our-team'),
          projectManager = document.querySelector('.project-manager');

    if(team || projectManager) {
      document.body.addEventListener('click', e=> {
        if(e.target.closest('.manager')) {
          e.preventDefault();//Відміняе перехід по ссилці 

          const manager   = e.target.closest('.manager'),
                managerId = manager.dataset.managerId;

          pageOverlay.add(document.body);
          pageOverlay.elemNode.style.zIndex = 100;

          let sliderHTML = `
          <div class="stories">
            <div class="stories__inner">
            <button class="close-btn close-btn--white stories__close-btn"></button>
            <div class="stories__author">
              <div class="stories__author-img">
                <img src="${manager.querySelector('.manager__pic img').getAttribute('src')}" alt="">
                </div>
              <p class="stories__author-name">${manager.querySelector('.manager__name').textContent}</p>
            </div>
            <div class="stories__slider stories-slider slider">
              

              <div class="swiper-container">
                <div class="swiper-wrapper">
                </div>
                
              </div>
              <div class="swiper-pagination slider__pagination"></div>

              <button class="swiper-button-prev slider__btn slider__btn--prev"><svg class="icon stories-icon stories-icon--left"><use xlink:href="img/design/symbol_sprite.svg#_stories-arrow-left"/></svg></button>
              <button class="swiper-button-next slider__btn slider__btn--next"><svg class="icon stories-icon stories-icon--right"><use xlink:href="img/design/symbol_sprite.svg#_stories-arrow"/></svg></button>
            </div>
            </div>
          </div>`
          document.body.insertAdjacentHTML('beforeEnd', sliderHTML);


          let stories      = document.querySelector('.stories'),
              storiesClose = document.querySelector('.stories__close-btn');
          


          storiesClose.onclick = () => {
            pageOverlay.remove();
            pageOverlay.elemNode.style.zIndex = '';

            stories.remove();
            stories = null;
          };
          loadStories(managerId);

          const storiesSlider = new Swiper('.stories-slider .swiper-container', {
            spaceBetween: 30,
            navigation: {
              prevEl: '.stories-slider .swiper-button-prev',
              nextEl: '.stories-slider .swiper-button-next',
            },

            pagination: {
              el: '.stories-slider .swiper-pagination',
              type: 'bullets',
              clickable: true,
            }
          });
          

          function loadStories(id) {
            let storiesData = {
              1: ['project7_img_1220.jpg', 'project1_img_1220.jpg', 'project3_img_1220.jpg'],
              2: ['poster.jpg', 'project10_img_1220.jpg'],
              3: ['project10_img_1220.jpg', 'project13_img_1220.jpg', 'project1_img_1220.jpg', 'project8_img_1220.jpg','poster.jpg', 'blog-preview1.jpg'],
              4: ['poster.jpg', 'work-proces_1220.jpg', 'blog-preview1.jpg'],
              5: ['company-life_920.jpg', 'com_920.jpg', 'work-proces_1220.jpg'],
            };
            let storiesSliderWrapper = document.querySelector('.stories-slider .swiper-wrapper');

            storiesData[id].forEach(fileName => {
              storiesSliderWrapper.insertAdjacentHTML('beforeEnd', `<div class="swiper-slide">
                <div class="stories-slider__img">
                  <img src="img/content/${fileName}" alt="">
                </div>

                </div>`);
            });

          }
        };
      });
    }

    const blogPreviewsSlider = new Swiper('.main-page__blog .swiper-container', {
      slidesPerView: 'auto',
      freeMode: true,
    })
    const cardSlider = new Swiper('.card-slider .swiper-container', {
      loop: true,

      pagination: {
        el: '.card-slider .swiper-pagination',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          if (current < 10) {
            current = `0${current}`;
          }
          console.log(swiper)
          if (total < 10) {
            total = `0${total}`;
          }
          console.log(current)
          return `<span class="swiper-pagination-current">${current}</span> &mdash; <span class="swiper-pagination-total">${total}</span>`
        }
      },

      navigation: {
        nextEl: '.card-slider .swiper-button-next',
        prevEl: '.card-slider .swiper-button-prev',
      }
    });

    const filterSlider = new Swiper('.filter__slider .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 20,

    })

    const reportSlider = new Swiper('.report-slider .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      
      breakpoints: {
        900: {
          spaceBetween: 30,
        },
      },

    })

    const workTimeSlider = new Swiper('.work-time__slider .swiper-container', {
      slidesPerView: 1,

      navigation: {
        nextEl: '.work-time__slider .swiper-button-next',
        prevEl: '.work-time__slider .swiper-button-prev',
      },

      pagination: {
        el: '.work-time__slider .swiper-pagination',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          if (current < 10) {
            current = `0${current}`;
          }

          if (total < 10) {
            total = `0${total}`;
          }

          return `<span class="swiper-pagination-current">${current}</span> &mdash; <span class="swiper-pagination-total">${total}</span>`
        }
      },


      breakpoints: {
        600: {
          slidesPerView: 3,
          spaceBetween: 30,

          navigation: false,
          pagination: false,
        }
      }
    });

    const companyLifeSlider = new Swiper('.company-life__slider .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      slidesPerColumn: 0,

      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerColumn: 2,
        },
        900: {
          slidesPerView: 3,
          slidesPerColumn: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          slidesPerColumn: 2,
          spaceBetween: 30,
        }
      }
    })
  }

    /* ===========================
    #SERVICE FUNCTION
  ============================= */
  
  function ifVisible(pos) {
    const bottomLine = html.clientHeight + html.scrollTop;

    if(pos < bottomLine) {
      return true;
    }
  }

  function getCoords(elem) {
    let c = elem.getBoundingClientRect();

    return {
      top: c.top + html.scrollTop,
      left: c.left,
      right: c.right,
      bottom: c.bottom + html.scrollTop
    }
  }

  function initOverlay() {
    let overlay = document.createElement('div');

    return {
      elemNode: overlay,
      add: function(parent) {
        // Додаю overlay
        parent.after(overlay);
        overlay.classList.add('overlay');
        overlay.classList.add('is-visible');
        // Виключаю скролл
        scrollOff();
      },

      remove: function() {
        //Удаляю overlay
        overlay.classList.remove('is-visible')
        // Включаю скролл
        scrollOn();

        setTimeout(() => {
          // e.preventDefault();
          overlay.remove();
        }, 500);
      }
    }
  };

  /* ===========================
    #ANIMATE PROGRESS
  ============================= */

  const progressArr = Array.from(document.querySelectorAll('.progress')).map(item => {

    return {
      elem:        item,
      pos:         getCoords(item),
      meter:       item.querySelector('.progress__meter'),
      out:         item.querySelector('.progress__out'),
      percent:     +item.dataset.doneBy,
    }
  });

  const animateProgress = function(progress) {
    if (progress.elem.classList.contains('is-visible')) return;
    let count = 0;

      progress.elem.classList.add('is-visible');

      let timerId = setTimeout(function counter() {
        count++;

        progress.meter.style.width = `${count}%`;
        progress.out.innerText = count;

        if (count >= progress.percent) {
          clearTimeout(timerId);
          return;
        }
        
        setTimeout(counter, 10);
      }, 10);
  };


  progressArr.forEach(item => {
    if(ifVisible(item.pos.top)) {
      animateProgress(item);
    }
  })

  window.addEventListener('scroll', e => {
    progressArr.forEach((item) => {

      if(ifVisible(item.pos.top)) {
        animateProgress(item);
      }
    })
  });


  
  /* ===========================
    #STAGE ANIMATION
  ============================= */
  {
    const scheduleItems = Array.from(document.querySelectorAll('.stage')),
          svg           = document.querySelector('.schedule__svg'),
          xmlns         = 'http://www.w3.org/2000/svg';

    if(html.clientWidth >= 1260) {

    const createAnimate = function(attr, values, dur, begin) {
      const animate = document.createElementNS(xmlns, 'animate');

      animate.setAttribute('attributeName', attr);
      animate.setAttribute('values', values);
      animate.setAttribute('dur', dur);
      animate.setAttribute('begin', begin);
      animate.setAttribute('fill', 'freeze');

      return animate;
    };

    const createPoint = function(yPos, fill) {
      const point   = document.createElementNS(xmlns, 'circle'),
            animate = createAnimate('r', '0;20;10', '.5s', 'indefinite');

      point.setAttributeNS(null, 'cx', '30px');
      point.setAttributeNS(null, 'cy', `${yPos}px`);
      point.setAttributeNS(null, 'r', 4);
      point.setAttributeNS(null, 'fill', fill);
      point.setAttribute('id', 'circle');

      point.append(animate);

      return {
        c: point,
        a: animate
      };
    };

    const createPath = function(yPos, lineLength) {
      const path    = document.createElementNS(xmlns, 'path'),
            animate = createAnimate('d', `M 30 ${yPos}, v 0; M30 ${yPos}, v${lineLength}`, '.5s', 'indefinite');
      path.setAttributeNS(null, 'd', `M 30 ${yPos}, v0`);
      path.setAttributeNS(null, 'stroke', 'grey');
      path.setAttributeNS(null, 'stroke-width', '.2px');

      path.append(animate);

      return {
        p: path,
        a: animate
      };
    };
    
    const animateSvg = function(elems) {
      
      elems.forEach((item, index, itemsArr) => {

        if(item.classList.contains('is-visible')) return;

        if(ifVisible(getCoords(item).top + html.clientHeight / 4)) {
          let m     = parseInt(getComputedStyle(item.parentElement).marginBottom),
              pos   = getCoords(item).top - getCoords(svg).top + (item.offsetHeight)/2,
              point,
              path,
              pathLength;

          if(index === 0) {
            pathLength = getCoords(itemsArr[index+1]).top + itemsArr[index+1].offsetHeight/2 - getCoords(svg).top - item.offsetHeight/2;

          } else if(index !== itemsArr.length-1) {
            pathLength = getCoords(itemsArr[index+1]).top + itemsArr[index+1].offsetHeight/2 - getCoords(item).top - item.offsetHeight /2;
          }

          const getBg = function(item) {
            if(item.classList.contains('stage--complate')) {
              return '#39BFC5';
            } else if(item.classList.contains('stage--process')) {
              return '#FF5722';
            } else {
              return '#FFD0C1';
            }
          };
          
          point = createPoint(pos, getBg(item));
          path = createPath(pos, pathLength);

          item.classList.add('is-visible');
          
          if(index === itemsArr.length - 1) {
            svg.append(point.c);
            point.a.beginElement();
          } else {
            svg.append(point.c);
            point.a.beginElement();
            svg.prepend(path.p);
            path.a.beginElement();
          }


        }
      })
    };

    animateSvg(scheduleItems);

    window.addEventListener('scroll', e=> {
      animateSvg(scheduleItems);
    });

    } else {
      const addVisible = function(elems){
        elems.forEach(item => {
          if(item.classList.contains('is-visible')) return;

          if(ifVisible(getCoords(item).top + html.clientHeight / 4)) {
            item.classList.add('is-visible');
          }
        })
      };

      addVisible(scheduleItems);

      window.addEventListener('scroll', e=> {
        addVisible(scheduleItems);
      })
    }
  }
  
  /* ===========================
    #FILTER
  ============================= */

  if(document.querySelector('#filter')) {
    const flt      = document.querySelector('#filter'),
          fltElems = Array.from(document.querySelectorAll('.js-filtered-elem'));

    let cat      = 'all',
        previews = [],
        articles;

    showFilterResult(cat);
    articles = getArticle(cat);

    flt.addEventListener('click', function(e) {

      if(e.target.tagName === 'BUTTON') {
        
        if(e.target.classList.contains('is-active')) {
          return;
        } else {
          let currentBtn = flt.querySelector('.filter__btn.is-active') || flt.querySelector('.projects-filter__btn.is-active');
          currentBtn.classList.toggle('is-active');
          e.target.classList.toggle('is-active');
        }

        fltElems.forEach(item => {
          item.classList.remove('is-active');
        })

        cat = e.target.dataset.category;
        showFilterResult(cat);
        articles = getArticle(cat);
        
      }
    });

    function showFilterResult(cat) {
      previews = [];
      if(cat === 'all') {
        fltElems.forEach((elem) => {
          elem.classList.add('is-visible');
        });
        previews = fltElems;

        previews[0].classList.add('is-active')
        return;
      }

      fltElems.forEach((elem)=> {
        if(elem.dataset.category === cat) {
          elem.classList.add('is-visible');
          previews.push(elem);
        } else {
          elem.classList.remove('is-visible');
        }

      });
      previews[0].classList.add('is-active');
    }

    function getArticle(cat) {
      let arr = [],
          articleList = Array.from(document.querySelectorAll('.article__content'));

      articleList.forEach(article=> {
        if(article.classList.contains('is-visible')) {
          article.classList.remove('is-visible');
        }
      });

      if(cat === 'all') {
        arr = articleList;
      } else {
        articleList.forEach((article, index) => {
          if(article.dataset.category === cat) {
            arr.push(article);
          }
        })
      }
      arr[0].classList.add('is-visible');
      return arr;
    }
    function toggleArticle(articles) {

    }
    document.querySelector('.blog__preview').addEventListener('click', function(e) {
      let articlePreview = e.target.closest('.blog__preview-item');

      if(articlePreview.classList.contains('is-active')) {
        return;
      } else {
        previews.forEach(preview => {
          if(preview.classList.contains('is-active')) {
            preview.classList.remove('is-active');
            articles.forEach(article => {
              if(preview.dataset.id === article.dataset.id) {
                article.classList.remove('is-visible');
              }
              if(articlePreview.dataset.id === article.dataset.id) {
                article.classList.add('is-visible');
              }
            })
          }
        })
        articlePreview.classList.add('is-active');
      }
    });
  }
  /* ===========================
    #SCROLL  ON/OFF
  ============================= */
  let getFixed = function() {
    let all = document.body.querySelectorAll('*');

    return Array.from(all).filter(elem => {
      let bool = getComputedStyle(elem).position === 'fixed';
      return bool;
    })
  }

  let fixedElements = getFixed();

  let scrollOn = function() {
    setTimeout(() => {

      document.body.classList.remove('scroll-off');
      document.body.style.paddingRight = '';
      fixedElements.forEach(elem => {
        elem.style.paddingRight = ``;
      })
    }, 300);
  }

  let scrollOff = function() {
    document.body.classList.add('scroll-off');
    document.body.style.paddingRight = `${scrollW}px`;
    fixedElements.forEach(elem => {
      elem.style.paddingRight = `${scrollW}px`
    });
  }


  /* ===========================
    #ACCORDION
  ============================= */

  const accordionsContainer = document.querySelector('.accordions'),
        accordionsArr       = document.querySelectorAll('.accordion');
  let currentItem           = document.querySelector('.accordion.is-open');
  
  if(currentItem) {
    currentItem.querySelector('.accordion__drop').style.height = `${parseInt(getComputedStyle(currentItem.querySelector('.accordion__txt')).height) + parseInt(getComputedStyle(currentItem.querySelector('.accordion__txt')).marginBottom)}px`;
  }

  const accordionClose = function(item) {

    item.classList.remove('is-open');
    item.querySelector('.accordion__drop').style.height = 0;

    //this code work for #FIXED SIDEBAR
    setTimeout(()=> {
      parentCoords = getCoords(bar.parentNode),
      topBound     = Math.abs(parentCoords.top),
      botBound     = Math.abs(parentCoords.bottom);
    }, 500)
  }

  const accordionOpen = function(item) {

    let s        = getComputedStyle(item.querySelector('.accordion__txt')),
        h        = parseInt(s.height),
        mb       = parseInt(s.marginBottom),
        itemDrop = item.querySelector('.accordion__drop');

    item.classList.add('is-open');
    itemDrop.style.height = `${h + mb}px`;
    //this code work for #FIXED SIDEBAR
    setTimeout(()=> {
      parentCoords = getCoords(bar.parentNode),
      topBound     = Math.abs(parentCoords.top),
      botBound     = Math.abs(parentCoords.bottom);
    }, 500)
  }

  if (accordionsContainer) {

    accordionsContainer.addEventListener('click', (e) => {
      if(e.target.closest('.accordion__panel')) {
        let accordion = e.target.parentElement;
        
        if(accordion.classList.contains('accordion')) {
          
          if(accordion === currentItem) {
            accordionClose(accordion);
            currentItem = null;
            

            return;
          }

          if(accordion !== currentItem && currentItem !== null) {
            accordionsArr.forEach(item => {
              if(item.classList.contains('is-open')) {
                accordionClose(item);
              }
            })
          }
          
          accordionOpen(accordion);
          currentItem = accordion;
          
        }
      }
    })
  }


  /* ===========================
    #BURGER / DROP MENU
  ============================= */


  let burger    = document.querySelector('.burger'),
    scrollW     = window.innerWidth - html.clientWidth;

  //Обробляе навігацію через клавішу ТАВ
  document.addEventListener('keyup', (e) => {
    if (!document.activeElement.closest('.drop-content')) {
      // Фокус покинув останній елемент і преходить знов на burger
      if (e.code === 'Tab' && dropMenu.classList.contains('is-visible')) {
        burger.focus();
      }
    }
  });

  window.addEventListener('resize', function(e) {

    if (innerWidth >= 1100 && burger.classList.contains('is-active')) {

      burger.classList.toggle('is-active');
      dropMenu.classList.toggle('is-visible');

      pageOverlay.remove();
    }
  })

  burger.addEventListener('click', function(e) {
    scrollW = window.innerWidth - html.clientWidth;

    burger.classList.toggle('is-active');
    dropMenu.classList.toggle('is-visible');

    if (dropMenu.classList.contains('is-visible')) {
      pageOverlay.add(dropMenu);

    } else {
      pageOverlay.remove();
    }
  });

  /* ===========================
    #MODAL
  ============================= */
  function modalInit(elem) {
    if(!elem) return;
    const m     = elem,
          mBody = m.querySelector('.modal__body');
    let btnOpen = document.getElementById('modal-open');
    function open() {
      m.classList.add('is-open');
    }
    function close() {
      m.classList.remove('is-open');
    }
    return {
      open: open,
      close: close
    }
  }

const modal = modalInit(document.getElementById('modal'));

document.body.addEventListener('click', function(e) {
  if(e.target.closest('#modal-open')) {
    e.preventDefault();
    modal.open();
    scrollOff();
    return;
  }
  if(e.target.closest('#modal-close')) {
    modal.close();
    scrollOn()
    return;
  }
});

  /* ===========================
    #MEDIA JUMPERS
  ============================= */
  // ***
  //* Пригаючому елементу присвоїти атрибут data-jump та data-jump-to
  //* В data-jump-to записати строку: 
  //* "newParentElementSelector.js-jump afterELementPosition mediaScreenWidth"
  //* newParentElementSelector.js-jump  - батьківський селектор + .js-jump
  //* afterELementPosition - після якого елемента вставляти 
  //* mediaScreenWidth - при якому розширенні переставляти
  //* 
  // ***

  let arr = document.querySelectorAll('[data-jump]');

  let jumpers = Array.from(arr).map(elem => {

    let param = elem.dataset.jumpTo.split(' ');
    // If in data-jump-to element position <= 0 showed alert(); 
    if (+param[1] < 0 || param[1] === '') {
      alert(`Error: bad value in data-jump-to: "... ${+param[1]} ..."`)
      return;
    }

    return {
      el: elem,
      realParent: elem.parentElement,
      realPrevElem: elem.previousElementSibling,
      newParent: document.querySelector(param[0]),
      newPos: +param[1],
      screen: +param[2],
    }
  })

  function jump() {
    screenW = window.innerWidth;

    jumpers.forEach(jumper => {
      if (screenW >= jumper.screen && jumper.el.dataset.jump) {
        // Обробляє прижок в початковий елемент 

        if (!jumper.realPrevElem) {
          jumper.realParent.prepend(jumper.el);

        } else {
          jumper.realPrevElem.after(jumper.el);
        }

        jumper.el.dataset.jump = '';
      }

      if (screenW < jumper.screen && !jumper.el.dataset.jump) {
        // Обробляє прижок в новий елемент

        if (!jumper.newParent.childElementCount) {
          jumper.newParent.append(jumper.el);
        } else if (jumper.newParent.childElementCount < jumper.newPos) {
          jumper.newParent.append(jumper.el)

        } else {
          if (jumper.newPos === 0) {

            jumper.newParent.prepend(jumper.el)
          } else {
            // [jumper.newPos -1] зміщую на одиницю. JS рахує починаючи з 0.
            jumper.newParent.children[jumper.newPos - 1].after(jumper.el);
          }
        }

        jumper.el.dataset.jump = 'moved';
      }

    })
  }
  jump();

  window.addEventListener('resize', function(e) {
    // Якщо змінюється висота екрана тоді перериваєм виконання функції
    if (window.innerWidth === screenW) return;
    jump()
  })


  /* ===========================
    #SVG DRAWIND LINE
  ============================= */
  {
    let lineInit = function(elem) {

      if (!elem) {
        // alert('Sory Mickle, from svg drawing line');
        return;
      }

      let list = document.querySelector('.steps__list'),
        itemsArr = document.querySelectorAll('.steps__item'),
        drawArea = document.querySelector('.steps__svg-wrap'),
        pathElem = document.querySelector('.svg__line'),
        circleElem = document.querySelector('.svg__circle'),
        itemsInRow,
        vIndent,
        hIndent = 10,
        lineStartPos = `M 5 0`;


      function draw() {
        elem.setAttribute('viewBox', `0 0 ${elem.parentNode.offsetWidth} ${elem.parentNode.offsetHeight}`);
        pathElem.removeAttribute('stroke-dasharray');
        pathElem.removeAttribute('stroke-dashoffset');

        itemsInRow = Math.round(list.offsetWidth / itemsArr[0].offsetWidth),
          vIndent = parseInt(getComputedStyle(itemsArr[0]).marginBottom);

        circleElem.setAttribute('cx', '5');
        circleElem.setAttribute('cy', '3');

        let str = '';

        str += `${lineStartPos} v${itemsArr[0].offsetHeight - vIndent/2}`;

        let tmpCount = itemsInRow;
        let rowLength = 0;

        itemsArr.forEach((item, i, arr) => {

          if (i < arr.length - 1) {

            if (i + 1 === tmpCount) {
              // обробляє останній елемент ряду
              rowLength += item.offsetWidth - hIndent;
              str += ` h${rowLength} v ${vIndent}`;
              str += ` h${-rowLength} v${arr[i+1].offsetHeight}`;

              rowLength = 0;
              tmpCount += itemsInRow;

            } else {
              // оброб. елемент
              rowLength += item.offsetWidth;

            }
          } else {
            // одробляе останній елемент в списку
            rowLength += item.offsetWidth - hIndent * 2;

            str += ` h${rowLength}`
          }

        });

        pathElem.setAttribute('d', str);
      };

      let animate = function() {
        if (list.classList.contains('is-visible')) return;

        let pos = elem.getBoundingClientRect().top;

        pathElem.setAttribute('stroke-dasharray', pathElem.getTotalLength());
        pathElem.setAttribute('stroke-dashoffset', pathElem.getTotalLength());

        if (pos < html.clientHeight / 2) {
          let lineAnimate = document.getElementById('line-animate'),
            circleAnimate = document.getElementById('circle-animate');
          circleAnimate.beginElement();
          list.classList.add('is-visible');
        }

        let timeInterval = parseInt(document.getElementById('line-animate').getAttribute('dur')) / itemsArr.length;
        document.querySelectorAll('.steps__item').forEach(function(item, index) {
          let delay = index * timeInterval;
          item.style.transitionDelay = "".concat(delay + .5, "s");
        });
      };


      draw();
      animate();

      window.addEventListener('resize', function(e) {
        draw();
      });

      window.addEventListener('scroll', function(e) {
        animate();
      });
    }

    lineInit(document.querySelector('.svg'));
  }

})
